import { TicketPercent } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

export const discountsListTour = defineTour({
  id: 'discounts.list',
  version: 1,
  group: 'marketing',
  route: '/_authed/_active/s/$storeId/discounts/',
  scope: 'store',
  requires: 'discounts.read',
  icon: TicketPercent,
  steps: [
    {
      id: 'list',
      kind: 'explain',
      variants: [
        { target: 'discounts.list.table' },
        { target: 'discounts.list.empty', copy: 'empty' },
      ],
    },
    {
      id: 'search',
      kind: 'action',
      target: 'discounts.list.search',
      advanceOn: { input: true },
      optional: true,
    },
    { id: 'create', kind: 'action', target: 'discounts.list.create', requires: 'discounts.write' },
  ],
  related: ['discounts.editor'],
});

export const discountEditorTour = defineTour({
  id: 'discounts.editor',
  version: 1,
  group: 'marketing',
  route: '/_authed/_active/s/$storeId/discounts/new',
  scope: 'store',
  requires: 'discounts.write',
  icon: TicketPercent,
  steps: [
    { id: 'method', kind: 'explain', target: 'discounts.editor.method', placement: 'right' },
    {
      id: 'applies-to',
      kind: 'explain',
      target: 'discounts.editor.applies-to',
      placement: 'right',
    },
    {
      id: 'conditions',
      kind: 'explain',
      target: 'discounts.editor.conditions',
      placement: 'right',
    },
    {
      id: 'combinations',
      kind: 'explain',
      target: 'discounts.editor.combinations',
      placement: 'right',
    },
    { id: 'limits', kind: 'explain', target: 'discounts.editor.limits', placement: 'right' },
    { id: 'save', kind: 'explain', target: 'discounts.editor.save', placement: 'left' },
  ],
  related: ['discounts.list', 'reports.sales'],
});
